import {
  Box,
  makeStyles,
  Modal,
  Step,
  StepLabel,
  Stepper,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import useGetReasonsRefusal from '../../../../hooks/reasonRefusal/useGetReasonsRefusal';
import { ApplicationState } from '../../../../store';
import ChildrenModal from '../childrenModal';
import FooterModal from '../FooterModal';
import './styles.scss';
import useGetDriver from '../../../../hooks/driver/useGetDriver';
const steps = [
  'Informações pessoais',
  'Foto de Perfil',
  'CNH',
  'CRLV',
  'Dados do veículo',
  'Fotos do veículo',
];

interface IModalDriverProps {
  openModal: boolean;
  setOpenModal: (value: boolean) => void;
  stepsToValidate?: number;
  driverId: string;
}

const ModalDriver: React.FC<IModalDriverProps> = ({
  openModal,
  setOpenModal,
  stepsToValidate = steps.length,
  driverId,
}) => {
  const { execute: getReasonsRefusal } = useGetReasonsRefusal();
  const { execute: getDriver } = useGetDriver();
  const driver = useSelector((state: ApplicationState) => state.driver);

  useEffect(() => {
    getReasonsRefusal({ page: 1, rowsPerPage: 10 });

    if (driverId) {
      getDriver(driverId);
    }
  }, [driverId]);

  const stepFounded = driver.refusedData?.find(reason => {
    if (reason.step > 6) {
      return 6;
    } else {
      return reason.step;
    }
  });
  const [activeStep, setActiveStep] = useState(stepFounded?.step || 0);
  const [step, setStep] = useState(stepFounded?.step || 1);

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1);
    setStep(prevStep => prevStep + 1);
  };

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1);
    setStep(prevStep => prevStep - 1);
  };

  const useStyles = makeStyles(() => ({
    root: {
      '& .MuiStepIcon-active': { color: '#ff3c00' },
      '& .MuiStepIcon-completed': { color: '#ff3c00' },
      '& .Mui-disabled .MuiStepIcon-root': { color: '#ff3c00' },
    },
  }));

  const style = useStyles();
  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(!openModal)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      keepMounted
    >
      <Box sx={{ width: '80%' }} className="modal-driver">
        <Stepper activeStep={activeStep} className={style.root}>
          {steps.slice(0, stepsToValidate).map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: {
              optional?: React.ReactNode;
            } = {};

            return (
              <Step key={index} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <ChildrenModal step={step} />
        <FooterModal
          openModal={openModal}
          setOpenModal={setOpenModal}
          handleBack={handleBack}
          handleNext={handleNext}
          currentStep={step}
          totalSteps={stepsToValidate}
        />
      </Box>
    </Modal>
  );
};

export default ModalDriver;
